export const goToCategories = (locale: string, category: string): void => {
  window.location.href = `/${locale}/categories/${category}`;
};

export const goToCustomization = (locale: string, id: number): void => {
  window.location.href = `/${locale}/customizations/${id}/edit`;
};
